import axios from "axios";
import { wmSign, wmAes, wm_aes_for_web } from "../../apiFunc/encrypt";
import { decrypt } from "../../apiFunc/decrypt";
import { EncryptRelay } from "../EncryptRelay/EncryptRelay";
import { GetTimeStamp, Get30Days } from "../../apiFunc/getDate";
import Cookies from "js-cookie";

const appURL = `${process.env.REACT_APP_APP_URL}/api`;
const oauthURL = `${process.env.REACT_APP_OAUTH_URL}/api`;
const appId = process.env.REACT_APP_ID;
const deviceUuid = process.env.REACT_APP_DEVICE_UUID;
const apiKey = process.env.REACT_APP_API_KEY;

const baseHeader = {
  "Content-Type": "application/json",
  "Accept-Language": "zh-TW",
  "app-id": appId,
  "device-uuid": deviceUuid,
};

/**mmrm api */
async function LoginMMRM(datatest) {
  function get_payload() {
    let payload = {
      K: apiKey,
      Q1: datatest.C_NO,
    };
    return JSON.stringify(payload);
  }
  let body = {
    request_parameter: {
      source: "project_member",
      verify_data: {
        payload: wmAes(get_payload()),
      },
    },
    timestamp: GetTimeStamp(),
  };
  const sign = wmSign(body);
  const data = {
    sign: sign,
  };
  const response = await axios.post(
    `${appURL}/member/login_with_external_member`,
    data,
    {
      headers: baseHeader,
    }
  );
  return response.data;
}

// WS02
async function verifyLoginData(datatest) {
  const url = "/app/vfy";
  const body = {
    Q1: datatest.account,
    Q2: datatest.password,
    K: apiKey,
    F: "JSON",
  };
  const payload = {
    http_method: "POST",
    merchant: "HTY",
    header: null,
    request_body_type: "x-www-form-urlencoded",
    body: body,
  };

  //   const sign = wmSign(body);
  //   const data = {
  //     sign: sign,
  //   };
  const response = await EncryptRelay({
    thirdPartyUrl: url,
    thirdPartyPayload: payload,
  });
  const { rcrm, results } = response;
  const decryptResult = decrypt(results.data.payload);
  if (rcrm.RC === "C01") {
    return { RC: rcrm.RC, RM: rcrm.RM, result: JSON.parse(decryptResult) };
  } else {
    return { RC: rcrm.RC, RM: rcrm.RM, result: null };
  }
}

async function GetAuthorize(datatest) {
  const randomKey = Cookies.get("random_key");
  const memberAccessToken = sessionStorage.getItem("member_access_token");
  const aesKeyForWeb = Cookies.get("aes_key");
  let xToken = undefined;
  if (datatest.memberAccessToken) {
    xToken = encodeURIComponent(wm_aes_for_web(datatest.memberAccessToken));
    localStorage.setItem("member_access_token", datatest.memberAccessToken);
  } else {
    xToken = encodeURIComponent(wm_aes_for_web(memberAccessToken));
  }
  const rurl = sessionStorage.getItem("rurl");
  
  const finalUrl = rurl + `&x_token=${xToken}&random_key=${randomKey}`;
  const header = {
    ...baseHeader,
    accept: "application/json",
  };
  let response = undefined;
  try {
    response = await axios.get(`${finalUrl}`, { headers: header });
  } catch (e) {
    response = { data: null };
  }

  return response.data;
}

export { verifyLoginData, LoginMMRM, GetAuthorize };
